<p-dialog
  header="Change Healthy Gourmet Kitchen status"
  [closable]="!submitting()"
  [modal]="true"
  [style]="{ width: '32rem' }"
  [visible]="visible()"
  (visibleChange)="onVisibleChange($event)"
>
  <p class="confirm-text">
    Set the status for
    <strong>{{ producerName() }}</strong>
  </p>

  <div class="field">
    <label class="field-label" for="producerStatus">Status</label>
    <p-select
      appendTo="body"
      inputId="producerStatus"
      optionLabel="label"
      optionValue="value"
      [disabled]="submitting()"
      [ngModel]="selectedStatus()"
      [options]="statusOptions"
      (ngModelChange)="selectedStatus.set($event)"
    ></p-select>
  </div>

  @if (consequenceMessage()) {
    <p-message
      styleClass="consequence-message"
      [severity]="selectedStatus() === ProducerStatus.Active ? 'success' : 'warn'"
      [text]="consequenceMessage()"
    ></p-message>
  }

  <ng-template pTemplate="footer">
    <p-button
      label="Cancel"
      severity="secondary"
      [disabled]="submitting()"
      [text]="true"
      (onClick)="onCancel()"
    ></p-button>
    <p-button
      icon="pi pi-check"
      label="Change status"
      severity="primary"
      [disabled]="confirmDisabled()"
      [loading]="submitting()"
      (onClick)="onConfirm()"
    ></p-button>
  </ng-template>
</p-dialog>
